import gql from 'graphql-tag';

//TODO not sure what to put for _approxshortcode vs _approxlongcode
const AUTO_SUGGEST_ISSUES = input => gql`
{
  topIssueCode(_approxshortcode: "${input}", _approxlongcode: "${input}") {
    candidateIssueCode {
      issueCode
      issueCodeDescription
    }
    confidence
  }
}
`

export default AUTO_SUGGEST_ISSUES
